module.exports = __webpack_public_path__ + "static/media/eqd-wall-clock.653dbdd4.jpg";